import { useEffect } from "react";
import { ThemeProvider } from "@/hooks/useTheme";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import IndustriesSection from "./components/IndustriesSection";
import ProcessSection from "./components/ProcessSection";
import ResultsSection from "./components/ResultsSection";
import CtaSection from "./components/CtaSection";
import Footer from "./components/Footer";

function HomeContent() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -60px 0px" }
    );
    const elements = document.querySelectorAll(".reveal");
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="font-sans overflow-x-hidden transition-colors duration-300">
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <IndustriesSection />
      <ProcessSection />
      <ResultsSection />
      <CtaSection />
      <Footer />
    </div>
  );
}

export default function Home() {
  return (
    <ThemeProvider>
      <HomeContent />
    </ThemeProvider>
  );
}
